import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import validate from 'validate.js';
import { Grid } from '@mui/material';
import moment from 'moment';
import {
  DialogDefaultV2,
  InputV2,
  DefaultSelectV2,
  TrueFalseSelectV2,
  NumberInputV2,
  DatePickerV2,
  UsuarioSelectV2,
} from '../../../components/v2';
import * as actionsDrones from '../../../store/drone/actions';
import * as selectorsDrones from '../../../store/drone/reducer';
import * as selectorsAuth from '../../../store/auth/reducer';

const schema = {
  tipoHistorico: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  dataHistorico: { presence: { allowEmpty: false, message: 'é obrigatório' } },
};

const schemaRepasse = {
  ...schema,
  tipoRepasse: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  posseEletropontes: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  usuario: { presence: { allowEmpty: false, message: 'é obrigatório' } },
};

const schemaManutencao = {
  ...schema,
  valorManutencao: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  observacao: { presence: { allowEmpty: false, message: 'é obrigatório' } },
};

const schemaVendaTroca = {
  ...schema,
  valorRecebido: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  observacao: { presence: { allowEmpty: false, message: 'é obrigatório' } },
};

const getSchema = (tipo) => {
  switch (tipo) {
    case 'MANUTENCAO': return schemaManutencao;
    case 'REPASSE': return schemaRepasse;
    case 'VENDA_TROCA': return schemaVendaTroca;
    default: return schema;
  }
};

const titleData = (tipo) => {
  switch (tipo) {
    case 'MANUTENCAO': return 'Data da Manutenção';
    case 'REPASSE': return 'Data da Entrega';
    case 'VENDA_TROCA': return 'Data da Transferência';
    default: return 'Data';
  }
};

const titleObservacao = (tipo) => {
  switch (tipo) {
    case 'MANUTENCAO': return 'Manutenção Realizada';
    case 'VENDA_TROCA': return 'Negociação (Observação)';
    default: return 'Observação';
  }
};

const HistoricoModal = ({ upsertHistorico, selectedHistoricoDrone, findHistoricoById, open, id, idDrone, onClose, afterSave, authData }) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open) {
      setValues({
        criadoPor: authData.id,
        criadoPorName: authData.nome,
        dataInclusao: moment().format('DD/MM/YYYY HH:mm:ss'),
      });
    } else {
      setValues({});
    }
  }, [authData, open]);

  useEffect(() => {
    if (id) findHistoricoById(id);
  }, [id, findHistoricoById]);

  useEffect(() => {
    if (id && selectedHistoricoDrone && id === selectedHistoricoDrone.id) {
      setValues(selectedHistoricoDrone);
    }
  }, [id, selectedHistoricoDrone]);

  const handleChange = (event) => setValues({ ...values, [event.target.name]: event.target.value });

  const handleChangeTipo = (event) => {
    setValues({ tipoHistorico: event.target.value });
    setErrors({});
  };

  const onSave = () => {
    const erros = validate(values, getSchema(values.tipoHistorico));
    setErrors(erros || {});
    if (!erros) {
      upsertHistorico({ ...values, drone: idDrone }, (success, data) => {
        if (success) {
          setValues({});
          setErrors({});
          onClose();
          afterSave(data);
        }
      });
    }
  };

  const onCloseLocal = () => {
    setErrors({});
    onClose();
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onCloseLocal}
      handlerConfirm={onSave}
      title="Histórico de Drone"
      confirmMessage="Salvar"
      maxWidth="md"
      fullWidth
    >
      <Grid container spacing={2}>
        <Grid size={{ xs: 3 }}>
          <DefaultSelectV2
            error={!!(errors.tipoHistorico)}
            isRequired
            label="Tipo do Histórico"
            name="tipoHistorico"
            showEmpty
            options={[
              { id: 'MANUTENCAO', nome: 'Manutenção' },
              { id: 'REPASSE', nome: 'Repasse' },
              { id: 'VENDA_TROCA', nome: 'Venda/Troca' },
            ]}
            onSelect={handleChangeTipo}
            value={values.tipoHistorico}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <DatePickerV2
            label={titleData(values.tipoHistorico)}
            error={!!(errors.dataHistorico)}
            onChange={(ts) => setValues({ ...values, dataHistorico: ts })}
            value={values.dataHistorico}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <InputV2 label="Criado Por" disabled value={values.criadoPorName || ''} />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <InputV2 label="Data Inclusão" disabled value={values.dataInclusao || ''} />
        </Grid>

        {values.tipoHistorico === 'REPASSE' && (
          <>
            <Grid size={{ xs: 6 }}>
              <UsuarioSelectV2
                label="Colaborador"
                onSelect={(usuario) => setValues({ ...values, usuario })}
                ativo
                value={values.usuario}
                error={!!(errors.usuario)}
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <InputV2 label="Região" name="regiao" onChange={handleChange} value={values.regiao || ''} />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <DefaultSelectV2
                error={!!(errors.tipoRepasse)}
                isRequired
                label="Tipo"
                name="tipoRepasse"
                showEmpty
                options={[
                  { id: 'ENTREGA', nome: 'Entrega' },
                  { id: 'DEVOLUCAO', nome: 'Devolução' },
                ]}
                onSelect={handleChange}
                value={values.tipoRepasse}
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <TrueFalseSelectV2
                error={!!(errors.posseEletropontes)}
                isRequired
                label="Está com Eletropontes"
                name="posseEletropontes"
                onChange={handleChange}
                value={values.posseEletropontes}
              />
            </Grid>
          </>
        )}

        {values.tipoHistorico === 'MANUTENCAO' && (
          <>
            <Grid size={{ xs: 4 }}>
              <NumberInputV2
                prefix="R$ "
                label="Valor da Manutenção"
                onChange={(valor) => setValues({ ...values, valorManutencao: valor })}
                value={values.valorManutencao}
                decimalScale={2}
                error={!!(errors.valorManutencao)}
                isRequired
              />
            </Grid>
            <Grid size={{ xs: 3 }}>
              <TrueFalseSelectV2 label="Foi Pago" name="pago" onChange={handleChange} value={values.pago} />
            </Grid>
            <Grid size={{ xs: 3 }}>
              <TrueFalseSelectV2 label="Emitiu Nota Fiscal" name="notaFiscal" onChange={handleChange} value={values.notaFiscal} />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <InputV2 label="Profissional Responsável" name="profissionalResponsavel" onChange={handleChange} value={values.profissionalResponsavel || ''} />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <InputV2 label="Empresa" name="empresa" onChange={handleChange} value={values.empresa || ''} />
            </Grid>
          </>
        )}

        {values.tipoHistorico === 'VENDA_TROCA' && (
          <Grid size={{ xs: 12 }}>
            <NumberInputV2
              prefix="R$ "
              label="Valor Recebido"
              onChange={(valor) => setValues({ ...values, valorRecebido: valor })}
              value={values.valorRecebido}
              decimalScale={2}
              error={!!(errors.valorRecebido)}
              isRequired
            />
          </Grid>
        )}

        {values.tipoHistorico && (
          <Grid size={{ xs: 12 }}>
            <InputV2
              label={titleObservacao(values.tipoHistorico)}
              name="observacao"
              onChange={handleChange}
              value={values.observacao || ''}
              rows={3}
              multiline
              error={!!(errors.observacao && (values.tipoHistorico === 'MANUTENCAO' || values.tipoHistorico === 'VENDA_TROCA'))}
            />
          </Grid>
        )}
      </Grid>
    </DialogDefaultV2>
  );
};

const mapStateToProps = (state) => ({
  selectedHistoricoDrone: selectorsDrones.getSelectedHistoricoDrone(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ ...actionsDrones }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(HistoricoModal));
